<template>
  <canvas class="ai-canvas" ref="canvas"></canvas>
</template>

<script>
import { AI_NAMES } from "vue-chess-shared/constants";

const sprites = {
  [AI_NAMES.CHESSIE]: "st004",
  [AI_NAMES.PROFESSOR_NINJA]: "st019",
  [AI_NAMES.ALIEN_BRAIN]: "st020",
};

export default {
  name: "AvatarSprite",

  props: ["player", "moveAction"],

  data() {
    return {
      isLoading: true,
    };
  },

  watch: {
    isReady() {
      if (!this.isReady) {
        return;
      }

      const manifest = [
        {
          id: this.spriteName + "_idle",
          src:
            "//sprite.skoolbo.com/spritesheets/Snazzimal_Idle/Recorder Camera/" +
            this.spriteName +
            "/spritesheet_128.png",
          crossOrigin: true,
        },
        {
          id: this.spriteName + "_victory_pump",
          src:
            "//sprite.skoolbo.com/spritesheets/Snazzimal_VictoryPump/Recorder Camera/" +
            this.spriteName +
            "/spritesheet_128.png",
          crossOrigin: true,
        },
        {
          id: this.spriteName + "_twirl",
          src:
            "//sprite.skoolbo.com/spritesheets/Snazzimal_Twirl/Recorder Camera/" +
            this.spriteName +
            "/spritesheet_128.png",
          crossOrigin: true,
        },
      ];

      this.loader.loadManifest(manifest);

      // clear the old sprite before drawing new one
      this.stage.removeAllChildren();
      this.stage.clear();
    },

    moveAction() {
      if (!this.sprite) return;

      this.sprite.gotoAndPlay(this.moveAction);
    },
  },

  computed: {
    isReady() {
      return !!(!this.isLoading && this.spriteName && this.$refs.canvas);
    },

    spriteName() {
      return sprites[this.player.first_name];
    },
  },

  methods: {
    loadSprite() {
      const spriteDef = {
        framerate: 30,
        frames: { width: 130, height: 130 },
        animations: {
          idle: [0, 36, "idle", 1],
          capture: [85, 136, "idle", 1],
          victory: [50, 83, "victory", 1],
        },
        images: [
          this.loader.getResult(this.spriteName + "_idle"),
          this.loader.getResult(this.spriteName + "_victory_pump"),
          this.loader.getResult(this.spriteName + "_twirl"),
        ],
      };

      this.sprite = new window.createjs.Sprite(
        new window.createjs.SpriteSheet(spriteDef)
      );
      this.sprite.regX = spriteDef.frames.width / 2;
      this.sprite.regY = spriteDef.frames.height / 2;
      this.sprite.x = this.stage.canvas.width / 2;
      this.sprite.y = this.stage.canvas.height / 2.5;

      window.createjs.Tween.get(this.sprite).to(
        { scaleX: 3, scaleY: 1.5 },
        600,
        window.createjs.Ease.bounceOut
      );

      this.stage.addChild(this.sprite);
      this.sprite.gotoAndPlay("idle");
    },
  },

  mounted() {
    this.stage = new window.createjs.Stage(this.$refs.canvas);
    window.createjs.Ticker.framerate = 60;
    window.createjs.Ticker.on("tick", this.stage);

    this.loader = new window.createjs.LoadQueue();
    this.loader.setMaxConnections(2);
    this.loader.addEventListener("complete", this.loadSprite);
    this.isLoading = false;
  },

  beforeDestroy() {
    this.loader.removeEventListener("complete", this.loadSprite);
  },
};
</script>

<style scoped>
.ai-canvas {
  width: 100%;
  height: 100%;
}
</style>
